var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import VueSelect from 'vue-select';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import apiGateway from '@/api-gateway';
import InputField from '@/components/input-field/InputField.vue';
import { StepBarAction } from '@/components/step-bar';
import GoogleMap from '@/components/GoogleMap.vue';
import projectStore from '../store/projectStore';
import { default as thailand } from '@/assets/data/thailand.json';
import { uniqBy, filter } from 'lodash';
var ManageProjectInfo = /** @class */ (function (_super) {
    __extends(ManageProjectInfo, _super);
    function ManageProjectInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formatOptions = [];
        _this.subFormatOptions = [];
        _this.projectTypeOptions = [];
        _this.projectRegionCodeOptions = [];
        _this.projectSubFormatCodeOptions = [];
        _this.regionOptions = [];
        _this.provinces = [];
        _this.districts = [];
        _this.subDistricts = [];
        _this.isAutogenerateProjectCode = true;
        _this.projectInfo = {};
        _this.infoData = __assign({}, projectStore.projectInfo);
        _this.gmapPosition = {
            lat: Number(projectStore.projectInfo.latitude || 13.825785),
            lng: Number(projectStore.projectInfo.longtitude || 100.6569564)
        };
        return _this;
    }
    Object.defineProperty(ManageProjectInfo.prototype, "projectName", {
        get: function () {
            var _this = this;
            var name = '';
            var regionCode = this.infoData.regionCode &&
                this.projectRegionCodeOptions.find(function (regionCode) { return regionCode.id === _this.infoData.regionCode; });
            var subFormatCode = this.infoData.subFormatCode &&
                this.projectSubFormatCodeOptions.find(function (subFormatCode) { return subFormatCode.id === _this.infoData.subFormatCode; });
            if (regionCode) {
                name += regionCode.name;
            }
            if (this.infoData.projectCode || regionCode || subFormatCode) {
                name += this.infoData.projectCode
                    ? this.infoData.projectCode.toString()
                    : '(xx)';
            }
            if (subFormatCode) {
                name += "-" + subFormatCode.name + " ";
            }
            name += this.infoData.name;
            return name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManageProjectInfo.prototype, "selectedFormat", {
        get: function () {
            return this.infoData.format;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManageProjectInfo.prototype, "selectedFormatData", {
        get: function () {
            var _this = this;
            return this.formatOptions.find(function (format) { return format.id === _this.selectedFormat; });
        },
        enumerable: false,
        configurable: true
    });
    ManageProjectInfo.prototype.handlePinPositionChanged = function (position) {
        this.infoData.latitude = position.lat;
        this.infoData.longtitude = position.lng;
    };
    // eslint-disable-next-line no-undef
    ManageProjectInfo.prototype.handleGeocodeResult = function (result) {
        if (!result)
            return;
        var address1 = '';
        for (var _i = 0, result_1 = result; _i < result_1.length; _i++) {
            var component = result_1[_i];
            var componentType = component.types[0];
            switch (componentType) {
                case 'street_number': {
                    address1 = component.long_name + " " + address1;
                    break;
                }
                case 'route': {
                    address1 = address1 + " " + component.short_name;
                    break;
                }
            }
        }
        this.infoData.address = address1;
    };
    ManageProjectInfo.prototype.onSelectAutogenerateProjectCode = function () {
        this.infoData.projectCode = undefined;
    };
    ManageProjectInfo.prototype.genEditInfoData = function () {
        if (this.isEdit &&
            this.projectInfo &&
            Object.keys(this.projectInfo).length) {
            this.infoData = {
                name: this.projectInfo.name || '',
                region: this.projectInfo.region || '',
                latitude: this.projectInfo.latitude,
                longtitude: this.projectInfo.longtitude,
                address: this.projectInfo.address || '',
                postcode: this.projectInfo.postcode,
                district: this.projectInfo.district || '',
                subdistrict: this.projectInfo.subdistrict || '',
                province: this.projectInfo.province || '',
                format: this.projectInfo.formatId || 1,
                buildingFloor: this.projectInfo.buildingFloor || '',
                subFormat: this.projectInfo.subFormatId || 1,
                type: this.projectInfo.projectTypeId || 1,
                regionCode: this.projectInfo.projectRegionCodeId || null,
                subFormatCode: this.projectInfo.projectSubFormatCodeId || null,
                projectCode: this.projectInfo.projectCode
            };
        }
    };
    ManageProjectInfo.prototype.infoDataChanged = function () {
        if (!this.isEdit) {
            projectStore.projectInfo = __assign(__assign({}, this.infoData), { latitude: Number(this.infoData.latitude), longtitude: Number(this.infoData.longtitude) });
        }
    };
    ManageProjectInfo.prototype.provinceChanged = function (value) {
        this.districts = this.getDistrictByProvinceCode(value);
        if (this.isEdit) {
            if (value === this.projectInfo.province) {
                this.infoData.district = this.projectInfo.district || '';
            }
            else {
                this.infoData.district = '';
            }
        }
        else {
            this.infoData.district = '';
        }
    };
    ManageProjectInfo.prototype.districtChanged = function (value) {
        this.subDistricts = this.getSubDistrictByDistrictCode(value);
        if (this.isEdit) {
            if (value === this.projectInfo.district) {
                this.infoData.subdistrict = this.projectInfo.subdistrict || '';
            }
            else {
                this.infoData.subdistrict = '';
            }
        }
        else {
            this.infoData.subdistrict = '';
        }
    };
    ManageProjectInfo.prototype.subDistrictChanged = function (value) {
        this.infoData.postcode = this.getPostcodeBySubDistrictCode(value);
    };
    ManageProjectInfo.prototype.formatChanged = function () {
        return __awaiter(this, void 0, Promise, function () {
            var includeSubFormat, includeType, includeRegionCode, includeSubFormatCode;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.fetchSubFormat(),
                            this.fetchProjectType(),
                            this.fetchProjectRegionCode(),
                            this.fetchProjectSubFormatCode()
                        ])];
                    case 1:
                        _a.sent();
                        includeSubFormat = this.subFormatOptions.filter(function (subformat) { return subformat.id === _this.infoData.subFormat; });
                        includeType = this.projectTypeOptions.filter(function (projectType) {
                            return projectType.id === _this.infoData.type;
                        });
                        includeRegionCode = this.projectRegionCodeOptions.filter(function (projectRegionCode) {
                            return projectRegionCode.id === _this.infoData.regionCode;
                        });
                        includeSubFormatCode = this.projectRegionCodeOptions.filter(function (projectSubFormatCode) {
                            return projectSubFormatCode.id === _this.infoData.subFormatCode;
                        });
                        this.infoData.subFormat =
                            includeSubFormat.length === 0 ? undefined : this.infoData.subFormat;
                        this.infoData.type =
                            includeType.length === 0 ? undefined : this.infoData.type;
                        this.infoData.regionCode =
                            includeRegionCode.length === 0 ? undefined : this.infoData.regionCode;
                        this.infoData.subFormatCode =
                            includeSubFormatCode.length === 0
                                ? undefined
                                : this.infoData.subFormatCode;
                        return [2 /*return*/];
                }
            });
        });
    };
    ManageProjectInfo.prototype.fetchFormats = function () {
        return __awaiter(this, void 0, Promise, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiGateway.getMyFormats()];
                    case 1:
                        resp = _a.sent();
                        this.formatOptions = resp.data || [];
                        return [2 /*return*/];
                }
            });
        });
    };
    ManageProjectInfo.prototype.fetchRegions = function () {
        return __awaiter(this, void 0, Promise, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiGateway.getMasterRegions()];
                    case 1:
                        resp = _a.sent();
                        this.regionOptions = resp.data || [];
                        return [2 /*return*/];
                }
            });
        });
    };
    ManageProjectInfo.prototype.fetchProjectInfo = function () {
        return __awaiter(this, void 0, Promise, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.projectId) return [3 /*break*/, 2];
                        return [4 /*yield*/, apiGateway.getProject(this.projectId)];
                    case 1:
                        resp = _a.sent();
                        this.projectInfo = resp.data || {};
                        this.gmapPosition = {
                            lat: Number(this.projectInfo.latitude),
                            lng: Number(this.projectInfo.longtitude)
                        };
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ManageProjectInfo.prototype.fetchSubFormat = function () {
        return __awaiter(this, void 0, Promise, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.infoData.format) return [3 /*break*/, 2];
                        return [4 /*yield*/, apiGateway.getSubFormat(this.infoData.format)];
                    case 1:
                        resp = _a.sent();
                        this.subFormatOptions = resp.data || [];
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ManageProjectInfo.prototype.fetchProjectType = function () {
        return __awaiter(this, void 0, Promise, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.infoData.format) return [3 /*break*/, 2];
                        return [4 /*yield*/, apiGateway.getProjectType(this.infoData.format)];
                    case 1:
                        resp = _a.sent();
                        this.projectTypeOptions = resp.data || [];
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ManageProjectInfo.prototype.fetchProjectRegionCode = function () {
        return __awaiter(this, void 0, Promise, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.infoData.format) return [3 /*break*/, 2];
                        return [4 /*yield*/, apiGateway.getProjectRegionCode(this.infoData.format)];
                    case 1:
                        resp = _a.sent();
                        this.projectRegionCodeOptions = resp.data || [];
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ManageProjectInfo.prototype.fetchProjectSubFormatCode = function () {
        return __awaiter(this, void 0, Promise, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.infoData.format) return [3 /*break*/, 2];
                        return [4 /*yield*/, apiGateway.getProjectSubFormatCode(this.infoData.format)];
                    case 1:
                        resp = _a.sent();
                        this.projectSubFormatCodeOptions = resp.data || [];
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ManageProjectInfo.prototype.prevStep = function () {
        if (this.isEdit) {
            this.$router.push({
                name: 'projects.info',
                params: {
                    id: this.projectId
                }
            });
        }
    };
    ManageProjectInfo.prototype.nextStep = function () {
        return __awaiter(this, void 0, Promise, function () {
            var isvalid;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validate()];
                    case 1:
                        isvalid = (_a.sent()).result;
                        if (isvalid) {
                            this.$router.push({
                                name: 'projects.create.particularpack',
                                query: this.$route.query
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ManageProjectInfo.prototype.updateProjectInfo = function () {
        return __awaiter(this, void 0, Promise, function () {
            var isvalid, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validate()];
                    case 1:
                        isvalid = (_a.sent()).result;
                        if (!isvalid) return [3 /*break*/, 3];
                        return [4 /*yield*/, apiGateway.updateProjectInfo(this.projectId, {
                                name: this.infoData.name,
                                subFormat: {
                                    connect: {
                                        id: this.infoData.subFormat
                                    }
                                },
                                type: {
                                    connect: {
                                        id: this.infoData.type
                                    }
                                },
                                regionCode: this.infoData.regionCode
                                    ? {
                                        connect: {
                                            id: this.infoData.regionCode
                                        }
                                    }
                                    : undefined,
                                projectCode: +this.infoData.projectCode || undefined,
                                subFormatCode: this.infoData.subFormatCode
                                    ? {
                                        connect: {
                                            id: this.infoData.subFormatCode
                                        }
                                    }
                                    : undefined,
                                region: this.infoData.region,
                                latitude: Number(this.infoData.latitude),
                                longtitude: Number(this.infoData.longtitude),
                                address: this.infoData.address,
                                postcode: this.infoData.postcode,
                                district: this.infoData.district,
                                subdistrict: this.infoData.subdistrict,
                                province: this.infoData.province,
                                buildingFloor: this.infoData.buildingFloor
                            })];
                    case 2:
                        resp = _a.sent();
                        if (resp.status === 200) {
                            this.$vs.notify({
                                color: 'success',
                                title: 'Project updated'
                            });
                            this.$router.push({
                                name: 'projects.info',
                                params: {
                                    id: this.projectId
                                }
                            });
                        }
                        else {
                            this.$vs.notify({
                                color: 'danger',
                                title: 'Project update Failed'
                            });
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ManageProjectInfo.prototype.validate = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = {
                            step: 'info'
                        };
                        return [4 /*yield*/, this.$refs.observer.validate()];
                    case 1: return [2 /*return*/, (_a.result = _b.sent(),
                            _a)];
                }
            });
        });
    };
    ManageProjectInfo.prototype.getAllProvince = function () {
        return uniqBy(thailand, 'province_code');
    };
    ManageProjectInfo.prototype.getDistrictByProvinceCode = function (name) {
        var listByCode = filter(thailand, { province: name });
        return uniqBy(listByCode, 'amphoe');
    };
    ManageProjectInfo.prototype.getSubDistrictByDistrictCode = function (name) {
        var lists = filter(thailand, function (db) {
            return db.district === name;
        });
        return lists;
    };
    ManageProjectInfo.prototype.getPostcodeBySubDistrictCode = function (name) {
        if (!name) {
            return undefined;
        }
        var lists = filter(thailand, {
            subdistrict: name
        });
        if (this.isEdit) {
            return lists.length > 0
                ? parseInt(lists[0].zipcode.toString())
                : this.projectInfo.postcode;
        }
        else {
            return lists.length > 0
                ? parseInt(lists[0].zipcode.toString())
                : undefined;
        }
    };
    ManageProjectInfo.prototype.beforeMount = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.provinces = this.getAllProvince();
                        return [4 /*yield*/, Promise.all([
                                this.fetchProjectInfo(),
                                this.fetchFormats(),
                                this.fetchRegions(),
                                this.fetchSubFormat(),
                                this.fetchProjectType(),
                                this.fetchProjectRegionCode(),
                                this.fetchProjectSubFormatCode()
                            ])];
                    case 1:
                        _a.sent();
                        this.isAutogenerateProjectCode = !this.infoData.projectCode;
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        Prop({
            type: String
        })
    ], ManageProjectInfo.prototype, "projectId", void 0);
    __decorate([
        Prop({
            required: true,
            type: Boolean
        })
    ], ManageProjectInfo.prototype, "isEdit", void 0);
    __decorate([
        Watch('projectInfo')
    ], ManageProjectInfo.prototype, "genEditInfoData", null);
    __decorate([
        Watch('infoData', { deep: true })
    ], ManageProjectInfo.prototype, "infoDataChanged", null);
    __decorate([
        Watch('infoData.province')
    ], ManageProjectInfo.prototype, "provinceChanged", null);
    __decorate([
        Watch('infoData.district')
    ], ManageProjectInfo.prototype, "districtChanged", null);
    __decorate([
        Watch('infoData.subdistrict')
    ], ManageProjectInfo.prototype, "subDistrictChanged", null);
    __decorate([
        Watch('selectedFormat')
    ], ManageProjectInfo.prototype, "formatChanged", null);
    __decorate([
        Emit('validate')
    ], ManageProjectInfo.prototype, "validate", null);
    ManageProjectInfo = __decorate([
        Component({
            components: {
                InputField: InputField,
                VueSelect: VueSelect,
                ValidationObserver: ValidationObserver,
                ValidationProvider: ValidationProvider,
                StepBarAction: StepBarAction,
                GoogleMap: GoogleMap
            }
        })
    ], ManageProjectInfo);
    return ManageProjectInfo;
}(Vue));
export default ManageProjectInfo;
